// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import moment from 'moment';
import Select from 'react-select';
import styler from 'react-styling';
import { FormGroup, FormControl, Button, Modal, Col, ButtonToolbar, ButtonGroup } from 'react-bootstrap/lib';

import { filterNotNullEdgeNodes } from '../../libs/Extract';
import getLanguage from '../../libs/Languages';
import { logError } from '../../libs/Logger';
import { getLocalDateFormat } from '../../libs/Time';

// harcoded: momentjs humanize is not accurate (1:30 being round up to '2 hours')
// and the decision was not to pull another lib for this.
const LocalLanguageData = getLanguage();
const durationOptions = [
  { value: 30, label: `30 ${LocalLanguageData.min}` },
  { value: 60, label: `1 ${LocalLanguageData.hour}` },
  { value: 90, label: `1 ${LocalLanguageData.hour} 30 ${LocalLanguageData.min}` },
  { value: 120, label: `2 ${LocalLanguageData.hours}` },
];

const defaultDuration = durationOptions[0];

const style = styler `
  Container
    width: fit-content
    min-width: 55vw
    margin: 25vh auto
    height: fit-content
  Header
    background-color: #182B56
    border-bottom: 0
    border-radius: 8px 8px 0 0
    padding: 3vh
  Title
    color: #FFF
    font-size: 3vh
    &Bold
      font-weight: 600
      margin-right: 1.3vh
  Body
    background-color: #FFF
    padding: 3vh
  BookButton
    width: 100%
    height: 10vh
    border-radius: 0px
    background-color: #B5F7B5
    color: #0A152D
    font-size: 3vh
    border: 0
  ModalCol
    height: 10vh
    font-size: 4vh
    background-color: #ECECEC
    border: 0
    border-radius: 0
    &Bottom
      margin-bottom: -15px
  ClockIcon
    margin: 0 5px
  Footer
    border-top: 0
    padding: 0
`;

const dateFormat = getLocalDateFormat();

class CreateMeetingroomEventModal extends Component {

  constructor(props) {
    super(props);
    const availableDurations = this._getAvailableDurationOptions(props.nextEvent, props.clock);
    this.state = {
      duration: availableDurations[0],
      availableDurations,
      organizer: null,
      validOrganizer: null,
    };
  }

  state: {
    duration: Object,
    availableDurations: Object[],
    organizer: ?Object,
    validOrganizer: ?boolean,
  };

  componentWillReceiveProps(nextProps) {
    const { availableDurations, duration } = this.state;
    const updatedDurations = this._getAvailableDurationOptions(nextProps.nextEvent, nextProps.clock);
    const updatedMaxDuration = updatedDurations[updatedDurations.length - 1];
    const lastMaxDuration = availableDurations[availableDurations.length - 1];
    if (updatedMaxDuration.value !== lastMaxDuration.value) {
      this.setState({
        // if last duration was the highest and updated is lower, then keep new highest as selected
        // otherwise just keep old (and still valid) duration as selected
        duration: (duration.value > updatedMaxDuration.value) ? updatedMaxDuration : duration,
        availableDurations: updatedDurations,
      });
    }
  }

  _getEventDates = (duration: number, now: Object) => {
    const start = moment(now);
    const end = moment(start).add(moment.duration(duration, 'minutes'));
    return {
      start,
      end,
    };
  }

  _handleDurationSelect = (duration: Object) => {
    this.setState({
      duration,
    });
  }

  _handleOrganizerSelect = (selectedOrganizer) => {
    let organizer = selectedOrganizer;
    let validOrganizer = true;
    // handle manual deletion of input
    if (!organizer || !organizer.email) {
      organizer = null;
      validOrganizer = false;
    }

    this.setState({
      organizer,
      validOrganizer,
    });
  }

  _handleContactSearch = (textFilter) => {
    this.props.relay.setVariables({
      textFilter: textFilter === '' ? null : textFilter,
      searchContact: true,
    });
  }

  _handleClose = () => {
    this.props.onClose();
    this._clearFilters();
  }

  _handleBook = () => {
    const { duration, organizer } = this.state;
    // need to check organizer, otherwise flow will complaint even though it's validated in validate()
    if (this._validate() && organizer) {
      const { meetingroom, clock } = this.props;
      const eventDates = this._getEventDates(duration.value, clock);

      const eventData = {
        chair: {
          email: organizer.email,
        },
        title: organizer.displayName,
        required: [{ email: meetingroom.email }, { email: organizer.email }],
        startDate: eventDates.start,
        endDate: eventDates.end,
        timezone: moment.tz.guess(),
      };
      const onSuccess = () => {
        this._handleClose();
      };
      const onError = (error) => {
        logError(error);
      };
      this.props.onBook(eventData, { onSuccess, onError });
    }
  }

  _validate = () => {
    if (this._isValidOrganizer() !== 'success') {
      this.setState({
        validOrganizer: false,
      });
      return false;
    }
    return true;
  }

  _clearFilters = () => {
    this.props.relay.setVariables({
      textFilter: null,
      searchContact: false,
    }, () => this.setState({
      organizer: null,
      duration: defaultDuration,
      validOrganizer: null,
    }));
  }

  props: {
    viewer: Object,
    relay: Object,
    show: boolean,
    lang: Object,
    clock: Object,
    meetingroom: Object,
    nextEvent: Object,
    onClose: Function,
    onBook: Function,
  };

  _extractContactOptions = (contacts: Object) => {
    const contactOpts = [];
    if (!contacts) {
      return contactOpts;
    }

    const contactList = filterNotNullEdgeNodes(contacts);
    if (contacts) {
      contactList.forEach(contact => {
        const c = contact;
        c.value = contact.email;
        c.label = contact.displayName;
        contactOpts.push(c);
      });
    }
    return contactOpts;
  }

  _isValidOrganizer = () => {
    const { validOrganizer } = this.state;
    switch (validOrganizer) {
      case null:
        return null;
      case true:
        return 'success';
      case false:
        return 'error';
      default:
        return null;
    }
  }

  _getAvailableDurationOptions = (nextEvent: Object, now: Object) => {
    if (!nextEvent) {
      return durationOptions;
    }

    const availableOptions = [];
    durationOptions.forEach(opt => {
      const duration = opt.value;
      const targetEnd = moment(now).add(moment.duration(duration, 'minutes'));
      if (targetEnd.isBefore(nextEvent.start)) {
        availableOptions.push(opt);
      }
    });

    if (availableOptions.length !== durationOptions.length) {
      // show an option filling the gap until next meeting
      // might be handy even when other options are available
      const durationUntilBusy = moment(nextEvent.start).diff(now, 'minutes');
      const maxDurationOption = {
        value: durationUntilBusy,
        label: '', // keep typecheck quiet
      };

      const showHour = (durationUntilBusy / 60) >= 1;
      if (showHour) {
        const minutes = durationUntilBusy % 60;
        maxDurationOption.label = `1 ${LocalLanguageData.hour} ${minutes} ${LocalLanguageData.min}`;
      } else {
        maxDurationOption.label = `${durationUntilBusy} ${LocalLanguageData.min}`;
      }

      availableOptions.push(maxDurationOption);
    }

    return availableOptions;
  }

  _renderAvilableTimes = (availableDurations: Array<Object>, duration: Object, handleDurationSelect: Function) => (
    <ButtonToolbar>
      <ButtonGroup>
        {availableDurations.map(dur =>
          <Button vlaue={dur.vlaue} onClick={() => handleDurationSelect(dur)}>{dur.label}</Button>
        )}
      </ButtonGroup>
    </ButtonToolbar>
  );

  render() {
    const { show, lang, meetingroom, viewer, clock } = this.props;
    const { organizer, duration, availableDurations } = this.state;
    const { displayName } = meetingroom;
    const contacts = this._extractContactOptions(viewer.contacts);
    const eventDates = this._getEventDates(duration.value, clock);
    let isValidEventOrganizer = this._isValidOrganizer();
    // avoid green tick when validation is successful
    isValidEventOrganizer = isValidEventOrganizer === 'success' ? null : isValidEventOrganizer;

    return (
      <Modal show={show} onHide={this._handleClose} className="meetingmodal" style={style.Container}>
        <Modal.Header closeButton style={style.Header}>
          <Modal.Title>
            <span style={style.Title.Bold}>{`${lang.book}`} {`${displayName}`}</span><span style={style.Title}>{moment(clock).format(dateFormat)} <i className="fa fa-clock-o" style={style.ClockIcon} /> {eventDates.start.format('H:mm')}—{eventDates.end.format('H:mm')}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={style.Body}>
          <form>
            <Col>
              <FormGroup controlId="selectPeriodCtrl">
                {this._renderAvilableTimes(availableDurations, duration, this._handleDurationSelect)}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup controlId="selectOrganizerCtrl" validationState={isValidEventOrganizer}>
                <Select
                  style={style.ModalCol.Bottom}
                  options={contacts}
                  onChange={this._handleOrganizerSelect}
                  onInputChange={this._handleContactSearch}
                  value={organizer}
                  clearable={true}
                  placeholder={lang.name}
                  arrowRenderer={() => undefined}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
          </form>
        </Modal.Body>
        <Modal.Footer style={style.Footer}>
          <Button bsStyle="success" style={style.BookButton} onClick={this._handleBook}>{lang.send_booking}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default Relay.createContainer(CreateMeetingroomEventModal, {
  initialVariables: {
    textFilter: null,
    searchContact: false,
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        contacts(first: 10, text: $textFilter ) @include(if: $searchContact) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/CreateMeetingroomEventModal.js